export type BadgeType = 'orange'|'lightgreen' | 'green' | 'blue' | 'grey'|'red' | 'mercury';
